import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import environmentConfig from "configuration/environmentConfig";

export type FlowInformation = {
  id: number;
};

export const getFlowQuery = async (): Promise<FlowInformation | null> => {
  try {
    const response = await axios.get(`/api/client/flows/${environmentConfig.quickStartCourseId}`, {
      headers: {
        MoboId: null,
      },
    });

    return response.data;
  } catch {
    return null;
  }
};

export const useGetFlowQuery = () => {
  return useQuery({
    queryKey: ["getFlowQuery"],
    queryFn: getFlowQuery,
  });
};
